import { render, staticRenderFns } from "./BulkMessaging.vue?vue&type=template&id=98c4dc62&"
import script from "./BulkMessaging.vue?vue&type=script&lang=ts&"
export * from "./BulkMessaging.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports